// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"hO-z","categoryName":"iO-z","categoryNameSearchHeader":"jO-z","categoryContent":"kO-z","bottomAligned":"lO-z","image":"mO-z","imageNoBackground":"nO-z"};